import { CANCEL, CATEGORY, SELECT_CATEGORY_TYPE } from 'Pages/GMS/ISR/ISRConstants';
import React, {useEffect, useState} from 'react';
import searchIcon from "../../../../../../assests/img/search-icon.svg";
import CategoryListItem from './CategoryListItem';
import {Data, TCategory, TIndexState, TProductCategory, TUpsertISRProjectDataModelsInput} from '../model';
import ConfirmDialog from "../../../Components/ConfirmDialog";
import {toast} from "react-toastify";

type TCategoryImportProps = {
    showCategoryMenu: boolean;
    setShowCategoryMenu: React.Dispatch<React.SetStateAction<boolean>>;
    categoryTypeList: string[];
    categoryData: Data[];
    selectedCategory: { type: string; data: TCategory[] } | null;
    setSelectedCategory: React.Dispatch<React.SetStateAction<{ type: string; data: TCategory[] } | null>>;
    setSelectedCategoriesMap: React.Dispatch<React.SetStateAction<{ [key: string]: TCategory[] }>>;
    selectedItems: TCategory[];
    setSelectedItems: React.Dispatch<React.SetStateAction<TCategory[]>>;
    setCategoryConfiguration: React.Dispatch<React.SetStateAction<TProductCategory | null>>;
    removeDataModelFieldMultiFilters: () => void;
}

const CategoryImport = ({showCategoryMenu, setShowCategoryMenu, categoryTypeList, categoryData, selectedCategory, setSelectedCategory, setSelectedCategoriesMap, selectedItems, setSelectedItems, setCategoryConfiguration, removeDataModelFieldMultiFilters}: TCategoryImportProps) => {
    const [searchInput, setSearchInput] = useState("");
    const [selectedCategoryType, setSelectedCategoryType] = useState<Data | null | undefined>(null);
    const [showDialog, setShowDialog] = useState(false);
    const [selectedCategoryLocal, setSelectedCategoryLocal] = useState<TCategory | null | undefined>(null);

    useEffect(() => {
        const selectedCategoryArray = selectedCategory?.data ?? [];
        let category: TCategory | null | undefined;
        if(selectedCategoryArray.length > 0) {
            const selectedCategoryItem = categoryData.filter((categoryType: any) => {
                const categories = categoryType.category.filter((category: any) => category.name === selectedCategory?.data[0].name);
                if(categories.length > 0) {
                    category = categories[0];
                }
                return categories.length > 0;
            });
            if(selectedCategoryItem.length > 0) {
                setSelectedCategoryType(selectedCategoryItem[0]);
                if(category) {
                    setSelectedCategoryLocal(category);
                }
            }
        } else {
            const selectedCategoryItem = categoryData.filter((categoryType: any) => categoryType.name === selectedCategory?.type);
            if(selectedCategoryItem.length > 0) {
                setSelectedCategoryType(selectedCategoryItem[0]);
            }
        }
  }, []);

    const toggleMenu = () => {
        setShowCategoryMenu(!showCategoryMenu);
    };

    const handleSearchInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchInput(event.target.value);
    };

    // const handleCategoryChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    //     const selectedCategoryType = event.target.value;
    //     const selectedCategoryItem = categoryData.find((item: any) => item?.name === selectedCategoryType);
    //     setSelectAll(false);
    //     setSelectedCategory(selectedCategoryItem ? { type: selectedCategoryType, data: selectedCategoryItem.category } : null);
    //     setSelectedItems([]);
    //     setSelectedCategoriesMap((prevMap) => ({
    //       [selectedCategoryType]: [],
    //     }));
    //     clearCategories();
    // };

    const handleCategoryChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedCategoryType = event.target.value;
        const selectedCategoryItem = categoryData.find((item: any) => item?.name === selectedCategoryType);
        setSelectedCategoryType(selectedCategoryItem);
      
        // Set the selected category and items
        setSelectedCategory(selectedCategoryItem ? { type: selectedCategoryType, data: selectedCategoryItem.category } : null);
      
        // Clear the selected items for the previous category type
        setSelectedItems([]);
      
        // Update the selected categories map for the current category type
        setSelectedCategoriesMap((prevMap) => ({
          [selectedCategoryType]: [],
        }));
        clearCategories();
      };
      

      const handleSelectCategoryLocal = (item: TCategory) => {
          setSelectedCategoryLocal(item);
      }


      const handleItemToggle = (item: TCategory) => {
        const isSelected = selectedItems.some((selectedItem) => selectedItem.id === item.id);
    
        // Clear previously selected items if not already selected
        const updatedSelectedItems = isSelected
            ? selectedItems.filter((selectedItem) => selectedItem.id !== item.id)
            : [item];
    
        setSelectedItems(updatedSelectedItems);
    
        if (selectedCategory && selectedCategory.type) {
            setSelectedCategoriesMap((prevMap) => ({
                ...prevMap,
                [selectedCategory.type]: updatedSelectedItems,
            }));
    
            setCategoryConfiguration((prevMap) => {
                if (!prevMap) return prevMap;
                const updatedData = {
                    ...prevMap.data,
                    categories: { type: selectedCategory.type, data: updatedSelectedItems },
                };
                return {
                    ...prevMap,
                    data: updatedData,
                };
            });
        }
    };
    

    const clearCategories = () => {
        setCategoryConfiguration((prevMap) => {
            if (!prevMap) return prevMap;
            const updatedData = {
                ...prevMap.data,
                categories: { type: '', data: [] },
            };
            return {
                ...prevMap,
                data: updatedData,
            };
        });
    }

    const handleDoneClick = () => {
        if(!selectedCategoryLocal) {
            toast.error('Select category to continue');
            return;
        }
        const isNewCategory = (selectedCategory?.data ?? []).length !== 1;
        if (!isNewCategory) {
            const prevCategoryId = selectedCategory?.data[0].id;
            if (prevCategoryId !== selectedCategoryLocal?.id) {
                removeDataModelFieldMultiFilters();
            }
        }
        handleItemToggle(selectedCategoryLocal);
        // if (selectedCategory && selectedCategory.type) {
        // setSelectedCategoriesMap((prevMap) => ({
        //     ...prevMap,
        //     [selectedCategory.type]: selectedItems,
        // }));
        // }

        // // Reset selected items and category after storing in the map
        // setSelectedItems([]);
        // setSelectedCategory(null);

        // // Close the menu or perform other actions as needed
        setShowCategoryMenu(false);
    };

    const filteredCategories = selectedCategoryType?.category.filter(category => {
            if (searchInput) {
                return category.name.toLowerCase().includes(searchInput.toLowerCase());
            }
            return true;
        }
    );

    const overlayClasses = 'tw-abosulte tw-inset-0 tw-bg-black tw-opacity-50 tw-z-40 tw-h-full tw-w-full';
    const menuClasses = showCategoryMenu ? 'tw-absolute tw-top-0 tw-right-0 tw-max-h-full tw-overflow-auto tw-inset-y-0 tw-right-0 tw-w-80 tw-bg-white tw-z-50 tw-transform tw-translate-x-0 tw-transition-transform tw-ease-in-out tw-duration-300' : ' tw-transform tw-translate-x-full tw-transition-transform tw-ease-in-out tw-duration-300';

    return (
        <React.Fragment>
            <div id="category-menu-container" className="tw-h-[calc(100vh-60px)] tw-fixed tw-top-0 tw-left-0 tw-w-screen tw-z-40 tw-mt-16">
                <div id="category-menu-overlay" className={overlayClasses} onClick={toggleMenu}/>
                <div id="category-menu" className={menuClasses}>
                    <div id="category-menu-header" className={`tw-flex tw-justify-between tw-items-center tw-px-4 tw-py-3 tw-sticky tw-top-0 tw-bg-white tw-z-10`}>
                        <h2 id="category-menu-title" className={`tw-text-black tw-font-semibold tw-text-sm`}>{CATEGORY}</h2>
                        <button id="category-menu-close" className={`tw-text-black`} onClick={toggleMenu}>X</button>
                    </div>
                    <div id="category-type-section" className='tw-mx-3'>
                        <select
                            id="category-type-dropdown"
                            className="drop-down-dm"
                            value={selectedCategory?.type ?? ''}
                            onChange={handleCategoryChange}
                        >
                            <option id="category-type-default">
                                {SELECT_CATEGORY_TYPE}
                            </option>
                            {categoryTypeList.map((item, index) => {
                                return (
                                    <option 
                                        id={`category-type-option-${index}`} 
                                        value={item} 
                                        key={item + index}
                                    >
                                        {item}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                    <div id="category-search-section" className='tw-flex tw-items-center tw-justify-between tw-gap-2 tw-mt-2 tw-mx-3'>
                        <div id="category-search-container" className='tw-flex tw-flex-grow tw-items-center tw-h-[32px] tw-p-2 tw-gap-3 tw-rounded-[4px] tw-border-[1px] tw-border-[#7676801F] tw-bg-white'>
                            <img id="category-search-icon" src={searchIcon} alt="Search Category" />
                            <input 
                                id="category-search-input" 
                                onChange={handleSearchInputChange} 
                                type="search" 
                                placeholder={"Search"} 
                                className='tw-w-full tw-text-[#747593] tw-font-normal focus:tw-outline-none tw-border-0 tw-text-xs tw-block tw-bg-transparent'
                            />
                        </div>
                    </div>
                    <div id="category-list-section" className='tw-mt-2 tw-mx-3'>
                        {filteredCategories && filteredCategories.length > 0 ? filteredCategories.map((item: TCategory, index: number) => {
                            return (
                                <CategoryListItem
                                    id={`category-list-item-${index}`}
                                    key={item.id}
                                    item={item}
                                    isSelected={selectedCategoryLocal?.id === item.id}
                                    onToggle={() => handleSelectCategoryLocal(item)}
                                />
                            );
                        }) : []}
                        <div id="category-actions" className='tw-flex tw-justify-end'>
                            <button 
                                id="category-cancel-btn"
                                className='btn-outlined' 
                                onClick={toggleMenu}
                            >
                                {CANCEL}
                            </button>
                            <button 
                                id="category-done-btn"
                                className='button-style' 
                                onClick={() => {
                                    const isNewCategory = (selectedCategory?.data ?? []).length !== 1;
                                    if(isNewCategory) {
                                        handleDoneClick();
                                    } else {
                                        const prevCategoryId = selectedCategory?.data[0].id;
                                        if(prevCategoryId === selectedCategoryLocal?.id) {
                                            handleDoneClick();
                                        } else {
                                            setShowDialog(true);
                                        }
                                    }
                                    console.log(selectedCategory);
                                }} 
                            >
                                Done
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {showDialog ? 
                <ConfirmDialog 
                    id="category-confirm-dialog"
                    title={'Alert'}
                    message={'This category may have other dependencies , are you sure you want to continue ?'}
                    onClose={() => {
                        setShowDialog(false);
                    }} 
                    onConfirm={() => {
                        handleDoneClick();
                        setShowDialog(false);
                    }}
                /> 
            : null}
        </React.Fragment>
    );
}

export default CategoryImport;